export class VendorsignUpModel {    
     PANNo :string=""; 
     UserName :any=""; 
     CompanyName :any; 
     GSTNo :string=''; 
     GSTVendorType : any ='';
     UnRegistered:boolean=false;
     Name :any; 
     Email :any; 
     ContactPerson :any; 
     MobileNo :any; 
     Address1 : string;
     Address2 : string;
     City_Code : string='';
     Post_Code : string='';
     State_Code : string='';


     BankAccNumber :any; 
     BankName :any; 
     BankAddress :any; 
     BankAddress2 : string;
     BankCity : string='';
     BankPostCode : string='';
     BankIFSCCode : any;
     ToCreateOrderAdress : boolean=false;
     VendorCode : string='';

     RegisterWith :any='NO';     
     MSMEType: string='Not-registered';
     MSMERegistrationDate: string='';

     File : any;
     PanFile : any;
     ChequeFile : any;
     RegisteredFile:any;
    }
export class CityState {
     City: any='';
     State: any='';
}